import { render, staticRenderFns } from "./contactSelector.vue?vue&type=template&id=b016bfe8"
import script from "./contactSelector.vue?vue&type=script&lang=js"
export * from "./contactSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports